import React from "react";

const BlackSection = () => {
    return(
        <p className="text-white"> adsfasd  </p>
    )
}

export default BlackSection;